import { ORGANIZATION_TYPE_INFLUENCER, ORGANIZATION_TYPE_INFLUENCERS_AGENCY } from 'utils/organization';

import { UserDropdownOrganization } from 'types';

interface OrgatizationData {
  organizationId: number,
  brandId?: number,
  influencerId?: number
}

export const getBrandIdFromOrganization = (org: UserDropdownOrganization): number | undefined => {
  const brandProfile = org?.type === 'brand' || org?.type === 'brand_agency'
    ? ((org.brandProfiles || [])[0] ?? null)
    : null;
  const brandId = brandProfile?.id ?? undefined;

  return brandId;
};

export const getInfluencerIdFromOrganization = (org: UserDropdownOrganization): number | undefined => {
  const influencerProfile = org.type === ORGANIZATION_TYPE_INFLUENCER || org.type === ORGANIZATION_TYPE_INFLUENCERS_AGENCY
    ? ((org.influencerProfiles || [])[0] ?? null)
    : null;
  const influencerId = influencerProfile?.id ?? undefined;

  return influencerId;
};

export const getOrganizationData = (org: UserDropdownOrganization): OrgatizationData => ({
  brandId: getBrandIdFromOrganization(org),
  influencerId: getInfluencerIdFromOrganization(org),
  organizationId: org.id
});
